export default __webpack_public_path__ + "static/media/java.f8f1b000.png";